import { render } from "./Vacature.vue?vue&type=template&id=384a804e&scoped=true"
import script from "./Vacature.vue?vue&type=script&lang=js"
export * from "./Vacature.vue?vue&type=script&lang=js"

import "./Vacature.vue?vue&type=style&index=0&id=384a804e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384a804e"]])

export default __exports__